import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ShoppingCartItemResponse } from '../../../../shared/services/responses/platform/get-shopping-cart.response';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../../../../shared/components/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-shopping-cart-item',
  standalone: true,
  imports: [CommonModule, FormsModule, CurrencyPipe, MatButtonModule, MatIconModule],
  templateUrl: './shopping-cart-item.component.html',
  styleUrls: ['./shopping-cart-item.component.css']
})
export class ShoppingCartItemComponent {
  @Input() item: ShoppingCartItemResponse;
  @Output() quantityChanged = new EventEmitter<{ idKit: number; quantity: number }>();

  constructor(private dialog: MatDialog) {}

  incrementQuantity(): void {
    this.item.quantity++;
    this.quantityChanged.emit({ idKit: this.item.idKit, quantity: this.item.quantity });
  }

  decrementQuantity(): void {
    if (this.item.quantity > 1) {
      this.item.quantity--;
      this.quantityChanged.emit({ idKit: this.item.idKit, quantity: this.item.quantity });
    } else {
      this.confirmRemoval();
    }
  }

  confirmRemoval(): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Remover Item',
        description: `Deseja remover "${this.item.bookTitle}" do seu carrinho?`,
        buttonConfirm: 'Sim, remover',
        buttonClose: 'Cancelar'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.confirm) {
        this.quantityChanged.emit({ idKit: this.item.idKit, quantity: 0 });
      }
    });
  }

  get itemTotal(): number {
    return this.item.totalPrice * this.item.quantity;
  }

  get shippingTotal(): number {
    // Simulação do frete por item. A lógica real dependerá da regra de negócio.
    return 5.99;
  }

  get totalWithShipping(): number {
    return this.itemTotal + this.shippingTotal;
  }
}